import axios from './axios_config';

export const deleteColumn = async (columnId) => {
    let result = await axios.delete(`/api/v1/column/${columnId}/`);
    return result;
};

export const updateColumn = async (columnId, data) => {
    let result = await axios.patch(`/api/v1/column/${columnId}/`, data);
    return result;
};
